export const COURSE_ENQUIRY_CONSENT = {
  legacy: "course-enquiry-v1",
  terms: "course-enquiry-terms-v2",
  termsUrl: "https://artha.link/terms-and-conditions/",
  privacyUrl: "https://artha.link/privacy-policy/",
} as const;
